import styled, { css } from "styled-components";
import { colors } from "../../consts";

const AsFormInput = css`
  padding: 16px;
  color: ${colors.RAISIN_70};
  border: 1px solid ${colors.RAISIN_20};

  ${(props) =>
    props.isActive &&
    `
    background-color: ${colors.RAISIN_10};
    border: 2px solid ${colors.RAISIN_100};
    color: ${colors.RAISIN_100};
    padding: 16px;
    `}
`;

export const OptionButtonStyled = styled.div`
  font-family: Plus Jakarta Sans;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0;
  text-align: left;
  color: ${colors.RAISIN_100};
  padding: 12px 16px;
  border-radius: 8px;
  width: 300px;
  cursor: pointer;

  ${(props) =>
    props.isActive &&
    `
    background-color: ${colors.RAISIN_10};
    border: 2px solid ${colors.RAISIN_100};
    padding: 10px 16px
    `}

  ${(props) =>
    props.disabled &&
    `
    color: ${colors.RAISIN_10};
    pointer-events: none;
    ${(props) =>
            props.secondary &&
            ` border: 2px solid ${colors.RAISIN_10};`}
`}
    
    
    ${(props) => props?.asFormInput && AsFormInput}
`;
